module.exports = __webpack_public_path__ + "static/media/buy-red-little.89eb08a2.png";